import React from 'react';

import { IBVControl } from '../../../models/BVControls/IBVControl';

import './bv-control.scss';

const BVControl: React.FunctionComponent<IBVControl> = ({ className, errorMessage, infoMessage, label, required, children }) => (
    <div className={`bv-control ${className} ${(!!errorMessage && 'bv-control-invalid')}`}>
        {label &&
            <span className="bv-control-label">{label} {required && <span className="bv-control-required">*</span>}</span>
        }

        {children}

        {infoMessage &&
            <span className="bv-control-feedback bv-feedback-info">{infoMessage}</span>
        }

        {errorMessage &&
            <span className="bv-control-feedback">{errorMessage}</span>
        }
    </div>
);

export default BVControl;